export default {"id":"icon-bg-standby-green"}